document.addEventListener('alpine:init', () => {
  function productFormContainer(data = {}) {
    return {
      ...data,

      isIntersectedFormContainer: true,

      onIntersectEnter() {
        this.isIntersectedFormContainer = true;
      },

      onIntersectLeave() {
        this.isIntersectedFormContainer = false;
      }
    };
  };

  Alpine.data('productFormContainer', productFormContainer);
});
